import React from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPrompt.css";

export default function LoginPrompt({ type = "profile" }) {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <div className="login-prompt-container">
      <div className="login-prompt-card">
        <div className="login-prompt-icon">
          🔐
        </div>
        <h3>Login Required</h3>
        <p>
          You need to be logged in to claim this {type}. 
          Please sign in or create an account to continue.
        </p>
        <div className="login-prompt-buttons">
          <button 
            className="login-prompt-btn primary"
            onClick={handleLoginClick}
          >
            Login / Sign Up
          </button>
        </div>
        <div className="login-prompt-note">
          <small>
            Claiming a {type} allows you to manage and update the information displayed.
          </small>
        </div>
      </div>
    </div>
  );
}
